<template>
  <b-card header="Lock Groups">
    <b-table
      :hover="true"
      :striped="false"
      :bordered="false"
      :small="false"
      :fixed="true"
      responsive="sm"
      :items="lockGroups"
      :fields="fields"
      :current-page="currentPage"
      :per-page="5"
      :filter="filter"
    >
      <template slot="action" slot-scope="data" style="float:right;">
        <b-button
          type="button"
          variant="danger"
          @click.stop="showModal(modalDeleteId(data.item.id), $event.target)"
          v-if="user.hausType == 1"
          style="float: right;margin-bottom:10px;"
        >
          <i class="fa fa-trash-o"></i>
        </b-button>

        <b-button
          type="button"
          variant="primary"
          @click.stop="showModal(modalEditId(data.item.id), $event.target)"
          style="float: right;margin-right: 10px;"
          v-if="user.hausType == 1"
        >
          <i class="fa fa-edit"></i>
        </b-button>
      </template>
    </b-table>
    <nav>
      <b-pagination
        :total-rows="getRowCount(lockGroups)"
        :per-page="5"
        v-model="currentPage"
        prev-text="Prev"
        next-text="Next"
        hide-goto-end-buttons
      />
    </nav>

    <div v-for="lg in lockGroups" :key="lg.id">
      <b-modal
        :id="'modaldelete' + lg.id"
        @ok="handleOk(lg.id, modalDeleteId(lg.id), $event.target)"
        centered
      >
        <div class="modal-window">
          <div class="alert alert-danger">
            <ul class="fa-ul" style="margin-bottom: 0px;">
              <li>
                <i class="fa fa-info-circle fa-li"></i>
                <p>
                  Are you sure you want to delete Lockgroup:
                  <br />
                  <strong>{{ lg.name }}</strong> ?
                </p>
              </li>
            </ul>
          </div>
        </div>
      </b-modal>

      <b-modal :id="'modaledit' + lg.id" ok-only ok-variant="secondary" ok-title="Cancel" centered>
        <div class="modal-window">
          <lock-group-edit-form :lockGroupId="lg.id" :modalEditId="modalEditId(lg.id)"></lock-group-edit-form>
        </div>
      </b-modal>
    </div>
  </b-card>
</template>

<script>
import LockGroupEditForm from "@/views/base/haus/LockGroupEditForm";
let qs = require("qs");
const constants = require("./shared/constants");
const BASE = constants.NEWPORT_CONST.API_URL;
const API = BASE + "/api/lockgroups/list/";
const API_DELETE_LG = BASE + "/api/lockgroups/delete";

function postdata(url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      "content-type": "application/x-www-form-urlencoded",
      accessToken: data.accessToken,
      access_token: data.access_token
    },
    method: "POST"
  }).then(res => res.json());
}

// async function getData() {
//   let parameters = {
//     client_id: constants.NEWPORT_CONST.CLIENT_ID,
//     client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
//     accessToken: localStorage.getItem("token"),
//     locationId: localStorage.getItem("locationId")
//   };
//   let res = await postdata(API, parameters);
//   return res.lockGroups;
// }

async function deletelg(groupId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem("token"),
    groupId: groupId,
    locationId: localStorage.getItem("locationId")
  };
  let res = await postdata(API_DELETE_LG, parameters);
  return res;
}

export default {
  name: "lock-group",
  components: {
    LockGroupEditForm
  },
  props: ["locationName", "locationDescription"],
  data: () => {
    return {
      user: {},
      lockGroups: [],
      fields: {
        name: {
          label: '<i class="icon-directions"></i>'
        },
        action: {
          label: '<i class="icon-menu"></i>'
        }
      },
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      filter: null
    };
  },
  mounted() {
    if (localStorage.getItem("token")) {
      this.user.hausType = localStorage.getItem("ouht");

      let localLocationList = localStorage.getItem("localLocationsList");
      let locationId = localStorage.getItem("locationId");

      if (localLocationList) {
        localLocationList = JSON.parse(localLocationList);
        this.$data.lockGroups = localLocationList.find(
          location => location.id == locationId
        ).lockgroups;
        //alert(JSON.stringify(this.$data.lockGroups))
      }

      // getData().then(response => {
      //   alert(JSON.stringify(response))
      //   this.$data.lockGroups = response
      // })
      this.$root.$on("lockGroups", lockGroupList => {
        this.lockGroups = lockGroupList;
      });
    }
  },
  methods: {
    modalEditId(i) {
      return "modaledit" + i;
    },
    modalDeleteId(i) {
      return "modaldelete" + i;
    },
    mailto(email) {
      return "mailto:" + email;
    },
    openlink(link) {
      location.href = link;
    },
    openlinkwithlocid(link) {
      let locId = localStorage.getItem("locationId");
      let uri = link + locId;
      location.href = uri;
    },
    getRowCount(items) {
      return items.length;
    },
    handleOk(id, modalId, button) {
      deletelg(id).then(res => {
        if (res.lockGroupId > 0) {
          let localLocationsList = localStorage.getItem("localLocationsList");
          let locationId = localStorage.getItem("locationId");

          if (localLocationsList) {
            localLocationsList = JSON.parse(localLocationsList);
            let locId = localLocationsList.findIndex(
              loc => loc.id == locationId
            );
            localLocationsList[locId].lockgroups.splice(
              localLocationsList[locId].lockgroups.findIndex(
                lg => lg.id == res.lockGroupId
              ),
              1
            );
            localStorage.setItem(
              "localLocationsList",
              JSON.stringify(localLocationsList)
            );

            let localLockList = localStorage.getItem('localLocksList')
            localLockList = JSON.parse(localLockList)

            localLockList = this.deleteLockgroup(id, localLockList)
            localStorage.setItem('localLocksList', JSON.stringify(localLockList))

            let updatedDeleteLockGroups = localLocationsList.find(
              location => location.id == locationId
            ).lockgroups;
            this.$root.$emit("lockGroups", updatedDeleteLockGroups);
          }
        }

        //alert(JSON.stringify(res))
        //after delete, refresh list of lockgroup
        // getData().then(dataList => {
        //   this.$root.$emit("lockGroups", dataList);
        //   this.$root.$emit("bv::hide::modal", modalId, button);
        // });
      });
    },
    showModal(id, button) {
      this.$root.$emit("bv::show::modal", id, button);
    },
    deleteLockgroup(locId, list) {
      return list.reduce((arr, current) => {
        var index = current.lockGroups.findIndex(lock => lock.lockGroupId == locId)
        if(index >= 0) {
           current.lockGroups.splice(index, 1)
        }
          arr.push(current);
          return arr;
      }, []);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/base/LockGroup.vue